/**
 * Created by Slava on 24.07.2024
 */

const ProlongationTutorial = function () {
    return new TutorialScenario(ProlongationTutorial.NAME, {
        onStart: function () {
            Game.currentGame.resetDices();
        },

        listSteps: ProlongationTutorial.listSteps,

        isAvailable: ProlongationTutorial.isAvailable
    });
};

ProlongationTutorial.listSteps = function () {
    const slot = ProlongationTutorial.getBestSlot();
    const selectedDices = ProlongationTutorial.getSelectedDices(slot);
    const roll = ProlongationTutorial.getRoll(slot, selectedDices);
    const steps = [];

    ProlongationTutorial.STEPS.forEach((data) => {
        data = cleverapps.clone(data);
        if (data.chooseDice !== undefined && selectedDices[data.chooseDice] === undefined) {
            return;
        }

        if (data.chooseDice !== undefined) {
            data.dice = selectedDices[data.chooseDice].id;
            delete data.chooseDice;
        }

        if (data.roll) {
            data.roll = roll;
        }

        if (data.slot) {
            data.slot = slot;
        }

        steps.push(YatzyTutorialHelper.createStep(data));
    });

    return steps;
};

ProlongationTutorial.getSelectedDices = function (slot) {
    const yatzy = Game.currentGame;
    let selectedDices = [];

    if (slot === Slot.YATZY) {
        selectedDices = YatzyTutorialHelper.find3DicesWithSameScore(true);
    } else if (slot === Slot.FULL_HOUSE) {
        const diceCount = yatzy.getDiceCount();
        yatzy.dices.forEach((dice) => {
            if (diceCount[dice.score] === 2) {
                selectedDices.push(dice);
            }
        });
    } else if (slot === Slot.LARGE_STRAIGHT) {
        const sequence = yatzy.getSequences().find((seq) => seq.length === 4);
        const used = [];

        yatzy.dices.forEach((dice) => {
            if (sequence.includes(dice.score) && !used[dice.score]) {
                selectedDices.push(dice);
                used[dice.score] = true;
            }
        });
    }

    return selectedDices;
};

ProlongationTutorial.getRoll = function (slot, selectedDices) {
    let score = selectedDices[0].score;
    if (slot === Slot.LARGE_STRAIGHT) {
        const minScore = Math.min.apply(null, selectedDices.map((dice) => dice.score));
        score = minScore < 3 ? minScore + 4 : 2;
    }

    return Game.currentGame.dices.map((dice) => {
        if (selectedDices.includes(dice)) {
            return dice.score;
        }

        return score;
    });
};

ProlongationTutorial.isAvailable = function () {
    const yatzy = Game.currentGame;
    if (cleverapps.forces.isShown(Forces.FREE_PROLONGATION_FORCE)
        || !yatzy
        || !yatzy.noRollsLeft()
        || !levels.user.checkAvailable(cleverapps.config.availables.FREE_PROLONGATION_FORCE)
    ) {
        return false;
    }

    return ProlongationTutorial.getBestSlot() !== undefined;
};

ProlongationTutorial.getBestSlot = function () {
    const yatzy = Game.currentGame;

    let slot = yatzy.slots[Slot.YATZY];
    if (!slot.used && slot.score === 0) {
        if (YatzyTutorialHelper.find3DicesWithSameScore(true)) {
            return Slot.YATZY;
        }
    }

    slot = yatzy.slots[Slot.FULL_HOUSE];
    if (!slot.used && YatzyTutorialHelper.hasTwoPairs()) {
        return Slot.FULL_HOUSE;
    }

    slot = yatzy.slots[Slot.LARGE_STRAIGHT];
    if (!slot.used && slot.score === 0) {
        const sequence = yatzy.getSequences().find((seq) => seq.length === 4);

        if (sequence) {
            return Slot.LARGE_STRAIGHT;
        }
    }
};

ProlongationTutorial.STEPS = [
    {
        chooseDice: 0,
        force: {
            text: "tutorial_prolongation_0"
        }
    },
    {
        chooseDice: 1,
        force: {
            text: ""
        }
    },
    {
        chooseDice: 2,
        force: {
            text: ""
        }
    },
    {
        chooseDice: 3,
        force: {
            text: ""
        }
    },
    {
        roll: true,
        force: {
            text: "tutorial_prolongation_1"
        }
    },
    {
        slot: true,
        force: {
            id: Forces.FREE_PROLONGATION_FORCE.id,
            text: "tutorial_prolongation_2"
        }
    }
];

ProlongationTutorial.NAME = "Prolongation";
